module.exports = __webpack_public_path__ + "img/avatar_7.1373f5a2.jpg";